module.exports = __webpack_public_path__ + "static/318411271_666024785193960_7166147818736642359_n.jpg-1671186393569-1152918cb4570040785a0d942a1078a7.webp";